const parseValue = (enteredValue: any, sf: number = 6) => {
  // Ignore invalid numbers
  if (isNaN(enteredValue)) return;

  // Prevent more than one decimal separator from being added.
  if (/\..*\./.test(enteredValue)) return;
  // Prevent input with > 6 sig figs. Assumes only one decimal separator.
  const regex = new RegExp(`[1-9](?:\\.?[0-9]){${sf - 1},}(?=\\.?[1-9])`);
  if (regex.test(enteredValue)) return;

  let value;
  if (enteredValue === null || enteredValue === undefined || enteredValue.trim() === '') {
    value = null;
  } else {
    value = Number(enteredValue).valueOf();
  }

  return value;
};

export default parseValue;
